'use client';

import classnames from 'classnames';
import { useState } from 'react';

type SubTabsProps = { tabs: Tabs; onClick?: (index: number) => void; active?: number };
type Tabs = { label: string; value: string }[];

const SubBoxTabs = ({ tabs, onClick, active }: SubTabsProps) => {
  const [current, setCurrent] = useState(active || 0);

  const onClickTab = (index: number) => () => {
    setCurrent(index);
    onClick?.(index);
  };

  return (
    <ul className='mt-4 flex items-center gap-2 overflow-x-scroll text-sm text-[#515c69]'>
      {tabs?.map(({ label }, index) => {
        const isActive = typeof active === 'number' ? active === index : index === current;

        return (
          <li
            key={label}
            className={classnames('cursor-pointer text-nowrap rounded-md bg-[#e8edf6] px-2 py-[2px]', {
              'bg-[#feede9] text-[#e03f19]': isActive
            })}
            onClick={onClickTab(index)}
          >
            {label}
          </li>
        );
      })}
    </ul>
  );
};

export default SubBoxTabs;
